import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=9bb21e12&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=9bb21e12&prod&lang=less&"
import style1 from "./Tag.vue?vue&type=style&index=1&id=9bb21e12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb21e12",
  null
  
)

export default component.exports